import { useSyncExternalStore } from 'react';
import { getRuntime, type Runtime, type RuntimeState } from './runtime.js';

export function useRuntime(): { rt: Runtime; state: RuntimeState } {
  const rt = getRuntime();
  const state = useSyncExternalStore(
    (fn) => rt.subscribe(fn),
    () => rt.getState(),
    () => rt.getState(),
  );
  return { rt, state };
}
